export default __webpack_public_path__ + "static/media/nft_arrow_dark.42c0439f.svg";